"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuItemLink_unstable", {
    enumerable: true,
    get: function() {
        return useMenuItemLink_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _useMenuItem = require("../MenuItem/useMenuItem");
const useMenuItemLink_unstable = (props, ref)=>{
    // casting because the root slot changes from div to a
    const baseState = (0, _useMenuItem.useMenuItem_unstable)(props, null);
    // FIXME: casting because the root slot changes from div to a,
    // ideal solution would be to extract common logic from useMenuItem_unstable root
    // and use it in both without assuming element type
    const _props = {
        ...props,
        ...baseState.root,
        ref,
        tabIndex: props.tabIndex
    };
    return {
        ...baseState,
        components: {
            ...baseState.components,
            root: 'a'
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('a', {
            role: 'menuitem',
            ..._props
        }), {
            elementType: 'a'
        })
    };
};
